import { observer } from "mobx-react-lite";

import { useTran } from "@/hooks";
import { Button } from "@/components/ui/button";
import { InputField } from "@/components/common";
import { useSurveyShareStore } from "../hooks";

const SurveyShareGuestTab = observer(({ onSendInvite }) => {
  const { t } = useTran();
  const shareStore = useSurveyShareStore();

  return (
    <>
      <div className="flex flex-1 flex-col rounded-radius border border-border bg-muted/40 p-4">
        <p className="text-sm font-semibold text-foreground">
          {t("Invite guest by email")}
        </p>
        <p className="text-xs text-muted-foreground">
          {t("Guests will receive a unique link to complete the survey.")}
        </p>
        <InputField
          value={shareStore.guestEmail}
          onChange={(event) => shareStore.setGuestEmail(event.target.value)}
          placeholder={t("guest@example.com")}
          className="mt-3"
        />
        {shareStore.guestEmailError ? (
          <p className="mt-2 text-xs text-destructive">
            {shareStore.guestEmailError}
          </p>
        ) : null}
        <InputField
          value={shareStore.guestMessage}
          onChange={(event) => shareStore.setGuestMessage(event.target.value)}
          placeholder={t("Optional message")}
          className="mt-3"
        />
        {shareStore.inviteUrl && (
          <div className="mt-4 rounded-md border border-border bg-muted/40 p-3">
            <p className="text-sm font-semibold">{t("Guest invite link")}</p>
            <a
              href={shareStore.inviteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-1 block text-xs text-blue-600 underline break-all"
            >
              {shareStore.inviteUrl}
            </a>
          </div>
        )}
      </div>

      <div className="mt-4 flex justify-end">
        <Button onClick={onSendInvite} disabled={shareStore.inviteUrl}>
          {shareStore.inviteLoading ? t("Sending...") : t("Send Invite")}
        </Button>
      </div>
    </>
  );
});

export default SurveyShareGuestTab;
